const contacts = [{
    "id": 1169525,
    "firstName": "Suzy",
    "lastName": "Hollifield",
    "email": "suzy.hollifield@chubb.com",
    "phoneNumber": "678-795-4238",
    "region": "Southeast",
    "states": ["AL", "GA", "LA", "MS"]
}, {
    "id": 1169533,
    "firstName": "Connie",
    "lastName": "Taylor",
    "email": "connie.taylor@chubb.com",
    "phoneNumber": "213-612-5371",
    "region": "Pacific",
    "states": []
}, {
    "id": 1169523,
    "firstName": "Jim",
    "lastName": "Hennessy",
    "email": "james.hennessy@chubb.com",
    "phoneNumber": "312-775-7916",
    "region": "Midwest",
    "states": ["AR", "IL", "KS", "MI", "MS", "MO", "OH", "MO", "WI"]
}, {
    "id": 1169521,
    "firstName": "Josh",
    "lastName": "Gibbons",
    "email": "joshua.gibbons@chubb.com",
    "phoneNumber": "617-261-6190",
    "region": "Northeast",
    "states": ["CT", "MA", "ME", "NH", "RI", "VT"]
}, {
    "id": 1169522,
    "firstName": "Jeffrey",
    "lastName": "Dietrich",
    "email": "jdietrich@chubb.com",
    "phoneNumber": "202-649-2233",
    "region": "Mid-Atlantic",
    "states": []
}, {
    "id": 1169529,
    "firstName": "Nicole",
    "lastName": "Troxell",
    "email": "ytroxell@chubb.com",
    "phoneNumber": "813-281-7519",
    "region": "Southeast",
    "states": ["FL"]
}, {
    "id": 1169520,
    "firstName": "Ryan",
    "lastName": "Vette",
    "email": "ryan.vette@chubb.com",
    "phoneNumber": "470-539-5392",
    "region": "Southeast",
    "states": ["GA", "NC", "TN", "SC"]
}, {
    "id": 1169524,
    "firstName": "Mia",
    "lastName": "Iverson",
    "email": "mia.iverson@chubb.com",
    "phoneNumber": "415-547-4612",
    "region": "Pacific",
    "states": ["AK", "CA", "HI", "ID", "MT", "OR", "WA"]
}, {
    "id": 1169528,
    "firstName": "Faye",
    "lastName": "Callahan",
    "email": "fcallahan@chubb.com",
    "phoneNumber": "312-529-6898",
    "region": "Midwest",
    "states": ["IL", "MN", "ND", "SD"]
}, {
    "id": 1169532,
    "firstName": "Brad",
    "lastName": "Smith",
    "email": "bjsmith@chubb.com",
    "phoneNumber": "312-659-6123",
    "region": "Midwest",
    "states": ["IA", "IL", "IN", "KS", "KY", "MO", "MN", "MT", "NE", "ND", "SD"]
}, {
    "id": 1169534,
    "firstName": "Queenie B",
    "lastName": "Gandy",
    "email": "qgandy@chubb.com",
    "phoneNumber": "908-605-3140",
    "region": "New York",
    "states": ["NJ", "NY"]
}, {
    "id": 1169526,
    "firstName": "Benjamin D",
    "lastName": "Dowd",
    "email": "bdowd@chubb.com",
    "phoneNumber": "214-754-8120",
    "region": "Southwest",
    "states": []
}, {
    "id": 1169519,
    "firstName": "Jessica",
    "lastName": "Yuspeh",
    "email": "jessica.yuspeh@chubb.com",
    "phoneNumber": "202-649-2213",
    "region": "Mid-Atlantic",
    "states": []
}, {
    "id": 1169535,
    "firstName": "Dave",
    "lastName": "Yeatman",
    "email": "",
    "phoneNumber": "416-359-3240",
    "region": "Canada",
    "states": ["CAN"]
}, {
    "id": 1169517,
    "firstName": "Irene T",
    "lastName": "Gaughan",
    "email": "igaughan@chubb.com",
    "phoneNumber": "516-745-8340",
    "region": "New York",
    "states": ["NY"]
}, {
    "id": 1169531,
    "firstName": "Nathan",
    "lastName": "Carter",
    "email": "ncarter@chubb.com",
    "phoneNumber": "213-612-5669",
    "region": "Pacific",
    "states": ["AZ", "CA"]
}, {
    "id": 1169527,
    "firstName": "Evelyn",
    "lastName": "Rawls",
    "email": "evelyn.rawls@chubb.com",
    "phoneNumber": "214-754-8589",
    "region": "Southwest",
    "states": ["AK", "LA", "OK", "TX"]
}, {
    "id": 1169530,
    "firstName": "Bryce E",
    "lastName": "Graham",
    "email": "begraham@chubb.com",
    "phoneNumber": "215-845-6015",
    "region": "Mid-Atlantic",
    "states": ["PA"]
}, {
    "id": 1169518,
    "firstName": "Kelly",
    "lastName": "Malone",
    "email": "Kelly.Malone@chubb.com",
    "phoneNumber": "914-989-6508",
    "region": "New York",
    "states": ["NY"]
}, {
    "id": 1214209,
    "firstName": "John",
    "lastName": "Fulse",
    "email": "Jc.fulse@chubb.com",
    "phoneNumber": "202-649-2213 ",
    "region": "Mid-Atlantic",
    "states": ["DC", "DE", "MD", "VA", "WV"]
}, {
    "id": 1278494,
    "firstName": "Andrew",
    "lastName": "Paulsen",
    "email": "apaulsen@chubb.com",
    "phoneNumber": "720-895-5127",
    "region": "Pacific",
    "states": ["CO", "NM", "NV", "UT", "WY"]
}, {
    "id": 1242850,
    "firstName": "Bryan",
    "lastName": "Marks",
    "email": "bryan.marks@chubb.com",
    "phoneNumber": "212-703-7047",
    "region": "New York",
    "states": []
}, {
    "id": 1278493,
    "firstName": "Chris",
    "lastName": "Sterling",
    "email": "christopher.sterling@chubb.com",
    "phoneNumber": "213-6125509",
    "region": "Pacific",
    "states": ["CA", "NV"]
}, {
    "id": 1242852,
    "firstName": "Eric",
    "lastName": "Lillegard",
    "email": "elillegard@chubb.com",
    "phoneNumber": "713-403-3082",
    "region": "Southwest",
    "states": []
}, {
    "id": 1242851,
    "firstName": "Jimmy",
    "lastName": "Dougherty",
    "email": "jdougherty@chubb.com",
    "phoneNumber": "925-598-6110",
    "region": "Pacific",
    "states": ["CA"]
}, {
    "id": 1242848,
    "firstName": "Rubin",
    "lastName": "Simkhayev",
    "email": "rsimkhayev@chubb.com",
    "phoneNumber": "212-461-5014",
    "region": "New York",
    "states": []
}];

export default contacts;



// WEBPACK FOOTER //
// ./src/data/contacts.js